import { Outlet } from 'react-router';

export const PublicPageLayout = () => {
  return (
    <div className="bg-canvas relative flex min-h-dvh w-full flex-col justify-start">
      <Outlet />
    </div>
  );
};
